import { useContext } from 'react';
import { useExtraConfigContext } from '@gov-nx/core/app';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { dataBoxLabel, getDataBoxTypeLabel } from '@gov-nx/module/data-box';
import { DalsiNastaveniDatovkyContext, PageCode } from '@gov-nx/module/page';
import { Button, Dialog, Icon, LayoutGap } from '@gov-nx/ui/web';

export const DataboxDisconnectModal = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tds = getLocalizeCurried(PageCode['datove-schranky']);
	const { extraConfig } = useExtraConfigContext();

	const context = useContext(DalsiNastaveniDatovkyContext);
	if (!context) {
		return null;
	}

	const {
		databoxId,
		databox,
		isDisconnectConfirmationOpen,
		closeDisconnectConfirmation,
		doDisconnect,
	} = context;

	const databoxLabel = databox
		? `${dataBoxLabel(databox, true)} – ${getDataBoxTypeLabel(
				databox.typSchranky,
				tds
			)} (${databoxId})`
		: '';

	const promptQuestionTranslation = tds(
		'odpojeni.opravdu-chcete-datovou-schranku-x-odpojit-z-portalu'
	);
	const promptQuestionParts = promptQuestionTranslation.split('{{label}}');
	const promptQuestion =
		promptQuestionParts.length === 2 ? (
			<>
				<span>{promptQuestionParts[0]}</span> <strong>{databoxLabel}</strong>{' '}
				<span>{promptQuestionParts[1]}</span>
			</>
		) : (
			promptQuestionTranslation
		);

	return (
		<Dialog
			isOpen={isDisconnectConfirmationOpen}
			onClose={closeDisconnectConfirmation}
			icon={
				<Icon
					name="exclamation-triangle-fill"
					type="components"
					color="error"
				/>
			}
			title={<h3>{tds('odpojeni.odpojeni-datovky-z-portalu-obcana')}</h3>}
			footer={
				<>
					<Button
						nativeType="button"
						color="primary"
						type="base"
						size="m"
						onClick={closeDisconnectConfirmation}
						aria-label={tds('odpojeni.neodpojovat')}>
						{tds('odpojeni.neodpojovat')}
					</Button>
					<Button
						nativeType="button"
						color="error"
						type="solid"
						size="m"
						onClick={doDisconnect}
						aria-label={tds('odpojeni.odpojit-datovku')}>
						{tds('odpojeni.odpojit-datovku')}
					</Button>
				</>
			}>
			<LayoutGap gap="s">
				<p>{promptQuestion}</p>
				{extraConfig.pageRoutes.databoxConfig
					.displayArchiveTextOnDataboxDisconnect ? (
					<>
						<p>
							{tds(
								'odpojeni.kopie-zprav-v-archivu-budete-mit-stale-v-portalu-obcana-dostupne'
							)}
						</p>
						<p>
							{tds(
								'odpojeni.datova-schranka-bude-nadale-pristupna-v-portalu-datovych-schranek'
							)}
						</p>
					</>
				) : null}
			</LayoutGap>
		</Dialog>
	);
};
